module.exports = __webpack_public_path__ + "static/index/img/baikal-105.7a25be79.jpg";